import { usePlayerSettings } from '@/stores/playerSettings'

const events = {
  sit: 'sit_on_table.mp3',
  your_turn: 'your_turn.mp3',

  flop: 'flop.mp3',
  turn: 'turn.mp3',
  river: 'river.mp3',

  raise: 'chips_to_table.mp3',
  fold: 'fold.mp3',
  check: 'check.mp3',
  bet: 'chips_to_table.mp3',
  all_in: 'all_in.mp3',

  chips_to_pot: 'chips_to_pot.mp3',
  timeover_5s_left: 'timeover_5s_left.mp3',

  winner: 'winner.mp3'
} as const

export async function playEvent(name: keyof typeof events) {
  const { sound } = usePlayerSettings()
  if (!sound) {
    return
  }

  const audio = new Audio(`/assets/mp3/${events[name]}`)
  try {
    await audio.play()
  } catch {
    // ok to  fail
  }
}
